<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div v-show="$route.path == '/Report/ReturnProduct'" class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label-required">วันที่เริ่มต้น:</label>
                  <div class="input-group date">
                    <input readonly type="text" class="form-control" placeholder="(วว/ดด/ปปปป)" id="reStartDate" name="reStartDate" ref="reStartDate" />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <!-- <i class="la la-calendar-check-o"></i> -->
                        <i class="la la-calendar"></i>
                      </span>
                    </div>
                  </div>
                  <span class="form-text"></span>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label-required">วันที่สิ้นสุด:</label>
                  <div class="input-group date">
                    <input readonly type="text" class="form-control" placeholder="(วว/ดด/ปปปป)" id="reEndDate" name="reEndDate" ref="reEndDate" />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <!-- <i class="la la-calendar-check-o"></i> -->
                        <i class="la la-calendar"></i>
                      </span>
                    </div>
                  </div>
                  <span class="form-text"></span>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">BARCODE:</label>
                  <input id="reBarcode" v-model="reBarcode" type="text" class="form-control"
                    placeholder="กรุณาระบุรหัส BARCODE (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ประเภทสินค้า:</label>
                  <treeselect id="reProductTypeId" v-model="reProductTypeId" :multiple="true" :options="reProductTypeIdOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">ชื่อสินค้า:</label>
                  <treeselect id="reProductCode" v-model="reProductCode" :multiple="true" :options="reProductCodeOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>แบรนด์สินค้า:</label>
                  <treeselect id="reProductBrandId" v-model="reProductBrandId" :multiple="true" :options="reProductBrandIdOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">เลขที่เอกสาร:</label>
                  <input id="reJobNumber" v-model="reJobNumber" type="text" class="form-control" placeholder="กรุณาระบุเลขที่เอกสาร" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>มุมมองผู้ใช้งาน:</label>
                  <treeselect id="reViewPermissionCode" v-model="reViewPermissionCode" :multiple="false" :options="reViewPermissionOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" @input="ChangeOptions('View')" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" v-if="reViewPermissionCode == 'BR_REPORT'">
                <div class="form-group">
                  <label>ชื่อคลังสินค้า:</label>
                  <treeselect id="rePlantCode" v-model="rePlantCode" :multiple="true" :options="rePlantCodeOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" v-if="reViewPermissionCode == 'BR_REPORT' || reViewPermissionCode == 'AGENT_REPORT'">
                <div class="form-group">
                  <label>ชื่อตัวแทนจำหน่าย:</label>
                  <treeselect id="reAgentCode" v-model="reAgentCode" :multiple="true" :options="reAgentCodeOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" @input="ChangeOptions('reAgentCode')" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ร้านค้า:</label>
                  <treeselect id="reShopCode" v-model="reShopCode" :multiple="true" :load-options="LoadreShopCodeOptions" :async="true"
                    :cacheOptions="true" searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา" placeholder="กรุณาเลือก"
                    v-on:open="resLoadreShopCodeOptions" ref="reShopCode" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ประเภทร้านค้า:</label>
                  <treeselect id="reShopTypeId" v-model="reShopTypeId" :multiple="true" :options="reShopTypeIdOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" v-if="reViewPermissionCode == 'BR_REPORT'">
                <div class="form-group">
                  <label>ขนส่ง:</label>
                  <treeselect id="reTransitId" v-model="reTransitId" :multiple="true" :options="reTransitIdOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" v-if="reViewPermissionCode == 'BR_REPORT'">
                <div class="form-group">
                  <label>สังกัด(ขนส่ง):</label>
                  <treeselect id="reTransitType" v-model="reTransitType" :multiple="true" :options="reTransitTypeOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ผู้ดำเนินการ:</label>
                    <treeselect id="reScanUserId"
                      v-model="reScanUserId"
                      :multiple="true"
                      :load-options="LoadreScanUserIdOptions"
                      v-on:open="reLoadreScanUserIdOptions"
                      :async="true"
                      :clear-on-select="true"
                      placeholder="กรุณาเลือก"
                      :cacheOptions="true"
                      ref="reScanUserId"
                    />
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button type="reset" class="btn btn-secondary" @click="formReset">
                  ล้างค่าทั้งหมด
                </button>
              </div>

              <div class="col-xl-6 text-right">
                <button class="btn btn-outline-primary" @click="ExportReturnProduct($event)" type="submit">
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="ReturnProductTable" style="width:100%">
                <thead>
                  <tr>
                    <th class="all text-right" colspan="16">
                      ข้อมูล ณ วันที่ {{ reDateReq }}
                    </th>
                  </tr>

                  <tr v-if="reViewPermissionCode == 'AGENT_REPORT'">
                    <th class="all text-center">ลำดับ</th>
                    <th class="all text-center">วันที่</th>
                    <th class="all text-center">เลขที่ใบงาน</th>
                    <th class="all text-center">รหัสตัวแทนจำหน่าย</th>
                    <th class="all text-center">ชื่อตัวแทนจำหน่าย</th>
                    <th class="all text-center">รหัสร้านค้า</th>
                    <th class="all text-center">ชื่อร้านค้า</th>
                    <th class="all text-center">ประเภทร้านค้า</th>
                    <th class="all text-center">ประเภทสินค้า</th>
                    <th class="all text-center">รหัสสินค้า</th>
                    <th class="all text-center">ชื่อสินค้า</th>
                    <th class="all text-center">แบรนด์สินค้า</th>
                    <th class="all text-center">BARCODE</th>
                    <!-- <th class="all text-center">จำนวน</th> -->
                    <th class="all text-center">ผู้ดำเนินการ</th>
                    <th class="all text-center"></th>
                  </tr>

                  <tr v-if="reViewPermissionCode == 'BR_REPORT'">
                    <th class="all text-center">ลำดับ</th>
                    <th class="all text-center">วันที่</th>
                    <th class="all text-center">เลขที่ใบงาน</th>
                    <th class="all text-center">รหัสคลังสินค้า</th>
                    <th class="all text-center">ชื่อคลังสินค้า</th>
                    <th class="all text-center">ขนส่ง</th>
                    <th class="all text-center">สังกัด(ขนส่ง)</th>
                    <th class="all text-center">รหัสตัวแทนจำหน่าย</th>
                    <th class="all text-center">ชื่อตัวแทนจำหน่าย</th>
                    <th class="all text-center">ประเภทสินค้า</th>
                    <th class="all text-center">รหัสสินค้า</th>
                    <th class="all text-center">ชื่อสินค้า</th>
                    <th class="all text-center">แบรนด์สินค้า</th>
                    <th class="all text-center">BARCODE</th>
                    <!-- <th class="all text-center">จำนวน</th> -->
                    <th class="all text-center">ผู้ดำเนินการ</th>
                  </tr>
                </thead>
                <tfoot v-show="isShowFooter == true">
                  <tr>
                    <th class="all text-center">จำนวนรวม</th>
                    <th class="all text-center">{{reTotalBarcode}}</th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
import DatatableWarning from "../../Shared/DatatableWarning";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function () {
    var self = this;

    return {
      isShowFooter: false,
      TotalAmount: 0,
      LoadFrist: true,
      errors: [],
      columns: null,
      reOrderBy: null,
      reViewPermissionCode: null,
      reViewPermissionOptions: [],
      reDateReq: null,
      reIsInitial: true,
      reDateCycle: null,
      reStartDate: null,
      reEndDate: null,
      reBarcode: null,
      reJobNumber: null,
      reProductTypeId: [],
      reProductTypeIdOptions: [],
      reProductCode: [],
      reProductCodeOptions: [],
      reProductBrandId: [],
      reProductBrandIdOptions: [],
      rePlantCode: [],
      rePlantCodeOptions: [],
      reAgentCode: [],
      reAgentCodeOptions: [],
      reShopCode: [],
      reShopCodeOptions: [],
      reShopTypeId: [],
      reShopTypeIdOptions: [],
      reTransitId: [],
      reTransitIdOptions: [],
      reTransitType: [],
      reTransitTypeOptions: [],
      reScanUserId: [],
      reScanUserIdOptions: [],
      reTotalBarcode: 0,
      selectedItems: [],
      options: [],
      isLoadingOptions: true,
    };
  },
  computed: {},
  methods: {
    formReset: function (e) {
      let self = this;

      self.reStartDate = null;
      self.reEndDate = null;
      self.reBarcode = null;
      self.reProductTypeId = [];
      self.reProductCode = [];
      self.reProductBrandId = [];
      self.reJobNumber = null;
      self.rePlantCode = [];
      self.reAgentCode = [];
      self.reShopCode = [];
      self.reShopTypeId = [];
      self.reTransitId = [];
      self.reTransitType = [];
      self.reScanUserId = [];

      $("#reStartDate").val("").trigger("change");
      $("#reEndDate").val("").trigger("change");
      $("#reBarcode").val("").trigger("change");
      $("#reProductTypeId").val("").trigger("change");
      $("#reProductCode").val("").trigger("change");
      $("#reProductBrandId").val("").trigger("change");
      $("#reJobNumber").val("").trigger("change");
      $("#rePlantCode").val("").trigger("change");
      $("#reAgentCode").val("").trigger("change");
      $("#reShopCode").val("").trigger("change");
      $("#reShopTypeId").val("").trigger("change");
      $("#reTransitId").val("").trigger("change");
      $("#reTransitType").val("").trigger("change");
      $("#reScanUserId").val("").trigger("change");

      this.formSubmit(e, e.target.innerText);
    },
    formResetValue: function (e) {
      let self = this;

      self.reStartDate = null;
      self.reEndDate = null;
      self.reBarcode = null;
      self.reProductTypeId = [];
      self.reProductCode = [];
      self.reProductBrandId = [];
      self.reJobNumber = null;
      self.rePlantCode = [];
      self.reAgentCode = [];
      self.reShopCode = [];
      self.reShopTypeId = [];
      self.reTransitId = [];
      self.reTransitType = [];
      self.reScanUserId = [];

      $("#reStartDate").val("").trigger("change");
      $("#reEndDate").val("").trigger("change");
      $("#reBarcode").val("").trigger("change");
      $("#reProductTypeId").val("").trigger("change");
      $("#reProductCode").val("").trigger("change");
      $("#reProductBrandId").val("").trigger("change");
      $("#reJobNumber").val("").trigger("change");
      $("#rePlantCode").val("").trigger("change");
      $("#reAgentCode").val("").trigger("change");
      $("#reShopCode").val("").trigger("change");
      $("#reShopTypeId").val("").trigger("change");
      $("#reTransitId").val("").trigger("change");
      $("#reTransitType").val("").trigger("change");
      $("#reScanUserId").val("").trigger("change");

      //this.formSubmit(e, "ล้างค่าทั้งหมด");
    },
    formSubmit: async function (e, innerText = null) {
      let self = this;
      var IsValidate = true;

      if (innerText == "ล้างค่าทั้งหมด") {
        self.reIsInitial = true;
      }

      e.preventDefault();

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      var table = $("#ReturnProductTable").DataTable();
      await self.GenCollums(table, "submit");
      // table.draw();
    },
    LoadrePlantCodeOptions: function (e) {
      var self = this;
      axios
        .post("/Api/Plant/Select2Plant", {
          all: true,
          page: 1,
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.rePlantCodeOptions = [];
            data.forEach((element) => {
              self.rePlantCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadreProductTypeIdOptions: function (e) {
      var self = this;
      axios
        .get("/Api/ProductType/Select2ProductType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reProductTypeIdOptions = [];
            data.forEach((element) => {
              self.reProductTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadreProductCodeOptions: function (e) {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reProductCodeOptions = [];
            data.forEach((element) => {
              self.reProductCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadreProductBrandIdOptions: function (e) {
      var self = this;
      axios
        .get("/Api/ProductBrand/Select2ProductBrand", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reProductBrandIdOptions = [];
            data.forEach((element) => {
              self.reProductBrandIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadreAgentCodeOptions: function (e) {
      var self = this;
      axios
        .post(
          "/Api/Report/Select2AgentPaymentProduct", {
          SalesAreaId: self.reSalesAreaId,
          page: 1,
          all: true,
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reAgentCodeOptions = [];
            data.forEach((element) => {
              self.reAgentCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadreSubAgentCodeOptions: function (e) {
      var self = this;
      axios
        .post("/Api/Report/Select2BarButlerShop", {
          SalesAreaId: self.reSalesAreaId,
          page: 1,
          all: true,
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reSubAgentCodeOptions = [];
            data.forEach((element) => {
              self.reSubAgentCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadreShopCodeOptions: _.debounce(function ({ action, searchQuery, callback }) {
      //this.$emit('activate', this.item)
      var self = this;
      if (action === "ASYNC_SEARCH") {
        axios
          .post("/Api/Report/Select2BarButlerShop", {
            Page: 1,
            All: true,
            Search: searchQuery,
            InActiveStatus: false,
            AgentCodes: self.reAgentCode,
            ShopCode: self.reSubAgentCode,
            RoleView: self.reViewPermissionCode
          })
          .then(function (response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.reShopCodeOptions = [];
              data.forEach((element) => {
                self.reShopCodeOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
              callback(null, self.reShopCodeOptions);
            }
          })
          .catch(function (error) { });
      }
    }, 3000),
    resLoadreShopCodeOptions: function () {
      this.$refs.reShopCode.trigger.searchQuery = null;
    },
    LoadreShopTypeIdOptions: function (e) {
      var self = this;
      axios
        .get("/Api/ShopType/Select2SearchShopType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reShopTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    // LoadreShopTypeIdOptions: function (e) {
    //   var self = this;
    //   axios
    //     .post("/Api/Report/Select2ShopAgentType", {
    //       page: 1,
    //       all: true,
    //       InActiveStatus: false,
    //       AgentCodes: self.reAgentCode,
    //       ShopCode: self.reSubAgentCode,
    //       RoleView: self.reViewPermissionCode
    //     })
    //     .then(function (response) {
    //       if (response.status == 200) {
    //         var data = response.data.results;
    //         self.reShopTypeIdOptions = [];
    //         data.forEach((element) => {
    //           self.reShopTypeIdOptions.push({
    //             id: element.id,
    //             label: element.text,
    //           });
    //         });
    //       }
    //     })
    //     .catch(function (error) { });
    // },
    LoadreSalesAreaIdOptions: function (e) {
      var self = this;
      axios
        .post("/Api/MasterSalesArea/Select2PaymentProduct", {
          page: 1,
          all: true,
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reSalesAreaIdOptions = [];
            data.forEach((element) => {
              self.reSalesAreaIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadreProvinceIdOptions: function (e) {
      var self = this;
      axios
        .post("/Api/Report/Select2PaymentProductProvince", {
          page: 1,
          all: true,
          salesAreaId: self.reSalesAreaId,
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reProvinceIdOptions = [];
            data.forEach((element) => {
              self.reProvinceIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadreTransitIdOptions() {
      var self = this;
      axios
        .post("/Api/Transport/Select2Transport", {
          showVendorTransport: false,
          agentCodes: [],
          isShowPickup: false,
          page: 1,
          search: null,
          isShowAll: true,
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reTransitIdOptions = [];
            data.forEach((element) => {
              self.reTransitIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadreTransitTypeOptions() {
      var self = this;
      axios
        .post("/Api/Transport/Select2TransportType", {
          showVendorTransport: false,
          agentCodes: [],
          isShowPickup: false,
          page: 1,
          search: null,
          isShowAll: true,
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reTransitTypeOptions = [];
            data.forEach((element) => {
              self.reTransitTypeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    reLoadreScanUserIdOptions: function(){
      this.$refs.reScanUserId.trigger.searchQuery = null;
    },
    LoadreScanUserIdOptions({ callback }) {
      var self = this;
      self.reScanUserIdOptions = [];
      if (self.isLoadingOptions) {
        axios
          .post("/Api/Report/Select2ScanUser", {
            page: 1,
            search: null,
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.reScanUserIdOptions = [];
              data.forEach((element) => {
                self.reScanUserIdOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
              self.isLoadingOptions = false;
            }
            callback(null, self.reScanUserIdOptions);
          });
      }
    },
    async LoadreViewReturnProductOptions() {
      var self = this;
      await axios
        .get("/Api/Report/Select2ViewReturnProduct", {})
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reViewPermissionOptions.push({
                id: element.id,
                label: element.text,
              });

              if (element.data == "active") {
                self.reViewPermissionCode = element.id;
              }
            });
          }
        })
        .catch(function (error) { });
    },
    ChangeOptions(type) {
      var self = this;
      if (self.LoadFrist == false) {
        if (type == "View") {
          self.formResetValue();
          self.LoadrePlantCodeOptions();
          self.LoadreAgentCodeOptions();
          // self.LoadreSubAgentCodeOptions();
          // self.LoadreShopCodeOptions();
          // self.LoadreShopTypeIdOptions();
          // self.LoadreSalesAreaIdOptions();
          // self.LoadreProvinceIdOptions();
        }
        else if (type == "reSalesAreaId") {
          // self.LoadreProvinceIdOptions(); // จังหวัด
          self.LoadreAgentCodeOptions(); // ตัวแทนจำหน่าย
          self.LoadreSubAgentCodeOptions(); // ตัวแทนจำหน่ายย่อย
          // self.LoadreShopCodeOptions(); // ร้านค้า
          // self.LoadreShopTypeIdOptions(); // ประเภทร้านค้า
        }
        else if (type == "reAgentCode") {
          // self.LoadreShopCodeOptions();
          // self.LoadreShopTypeIdOptions();
        }
        else if (type == "reSubAgentCode") {
          // self.LoadreShopCodeOptions();
          // self.LoadreShopTypeIdOptions();
        }
        else if (type == "reShopCode") {
          // self.LoadreShopTypeIdOptions();
        }
      }
    },
    GenCollums(table, action) {
      var self = this;
      self.columns = null;

      if (self.reViewPermissionCode == "AGENT_REPORT") {
        self.columns = [
          {
            data: "jobId",
            className: "text-center",
            render: function (data, type, full, meta) {
              var t = table.DataTable();
              var page = t.page.info().start + 1;
              return page + meta.row;
            },
          },
          {
            data: "jobDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.jobDateString;
            },
          },
          { data: "jobNumber", className: "text-center" },
          { data: "agentCode", className: "text-center" },
          { data: "agentName", className: "text-center" },
          { data: "cusT_CODE", className: "text-center" },
          { data: "shopName", className: "text-center" },
          { data: "shopTypeName", className: "text-center" },
          { data: "productTypeName", className: "text-center" },
          { data: "productCode", className: "text-center" },
          { data: "productName", className: "text-center" },
          { data: "productBrandName", className: "text-center" },
          { data: "barcodeNoOld", className: "text-center" },
          // { data: "countBarcode", className: "text-center" },
          { data: "scanByUserName", className: "text-center" },
          { data: "jobId", className: "text-center", visible: false },
        ];
      }
      else {
        self.columns = [
          {
            data: "jobId",
            className: "text-center",
            render: function (data, type, full, meta) {
              var t = table.DataTable();
              var page = t.page.info().start + 1;
              return page + meta.row;
            },
          },
          {
            data: "jobDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.jobDateString;
            },
          },
          { data: "jobNumber", className: "text-center" },
          { data: "plantCode", className: "text-center" },
          { data: "plantName", className: "text-center" },
          { data: "caR_REG", className: "text-center" },
          { data: "companY_NAME", className: "text-center" },
          { data: "agentCode", className: "text-center" },
          { data: "agentName", className: "text-center" },
          { data: "productTypeName", className: "text-center" },
          { data: "productCode", className: "text-center" },
          { data: "productName", className: "text-center" },
          { data: "productBrandName", className: "text-center" },
          { data: "barcodeNoOld", className: "text-center" },
          // { data: "countBarcode", className: "text-center" },
          { data: "scanByUserName", className: "text-center" }
        ];
      }

      if (action == "submit") {
        table.clear();
        table.destroy();
        table = $("#ReturnProductTable");
        self.GetDataTable(table);
      }
    },
    GetDataTable(table) {
      var self = this;
      $.fn.dataTable.ext.errMode = 'none';
      table
        .DataTable({
          autoWidth: true,
          scrollY: "100%",
          scrollX: true,
          responsive: true,
          processing: true,
          serverSide: true,
          searchDelay: 500,
          ajax: {
            url: "/Api/Report/ReturnProduct",
            type: "post",
            dataType: "json",
            contentType: "application/json",
            beforeSend: function (request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            },
            data: function (d) {

              let jsonSearch = {
                IsInitial: self.reIsInitial,

                StartDate:
                  self.reStartDate != null
                    ? self.reStartDate.format("DD/MM/YYYY")
                    : null,

                EndDate:
                  self.reEndDate != null
                    ? self.reEndDate.format("DD/MM/YYYY")
                    : null,

                Barcode: self.reBarcode,
                ProductTypeId: self.reProductTypeId,
                ProductCode: self.reProductCode,
                ProductBrandId: self.reProductBrandId,
                PlantCode: self.rePlantCode,
                AgentCode: self.reAgentCode,
                ShopCode: self.reShopCode,
                ShopTypeId: self.reShopTypeId,
                TransitId: self.reTransitId,
                TransitType: self.reTransitType,
                ScanUserId: self.reScanUserId,
                ViewPermissionCode: self.reViewPermissionCode,
                JobNumber: self.reJobNumber
              };
              return JSON.stringify($.extend(d, jsonSearch));
            },
          },
          // DOM Layout settings
          dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

          lengthMenu: [50, 100, 200, 500],

          pageLength: 100,

          language: {
            lengthMenu: "Display _MENU_",
          },
          // Order settings
          order: [[1, "desc"]],
          columns: self.columns,
          drawCallback: function (settings) {
            self.reIsInitial = false;
            self.reDateReq = moment().format("DD/MM/YYYY h:mm a");
            self.reTotalBarcode = 0;

            // if (settings.json.data.length > 0) {
            //   var data = settings.json.data;
            //   data.forEach((element) => {
            //     self.reTotalBarcode = self.reTotalBarcode + element.countBarcode;
            //   });
            // }

            var allPage = table.DataTable().page.info().pages;
            var currentPage = table.DataTable().page.info().page +1;
            self.isShowFooter = false;
            if(allPage == currentPage){
              self.isShowFooter = true;
              self.reTotalBarcode = settings.json.data[0].totalBarcode;
            }
          },
        })
        .on("preXhr.dt", function () {
          console.log("preXhr.dt");
          KTApp.block(self.$refs.form, {
            showOverlay: false,
            opacity: 0.05,
            message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
          });
        })
        .on("xhr.dt", function () {
          console.log("xhr.dt");
          KTApp.unblock(self.$refs.form);
        })
        .on("error.dt", function ( e, settings, techNote, message ) {
          DatatableWarning.alert(techNote);
        })
        .on("draw.dt", function () {
          console.log("draw.dt");
          // var t = table.DataTable();
          // var page = t.page.info().start + 1;
          // t.column(0, {}).nodes().each( function (cell, i) {
          //     cell.innerHTML = i+page;
          // } );
        });
    },
    ExportReturnProduct: function (e) {
      let self = this;
      e.preventDefault();
      
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      // if (
      //   !self.reMmBarcode &&
      //   !self.reMmDepartmentMaterialCode &&
      //   !self.reMmNFCCode &&
      //   !self.reMmTransactionDateStart &&
      //   !self.reMmTransactionDateEnd
      // ) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกเงื่อนไขรายงาน", "warning");
      //   return false;
      // }

      // if (!self.reMmTransactionDateStart && self.reMmTransactionDateEnd) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(เริ่มต้น)", "warning");
      //   return false;
      // } else if (
      //   self.reMmTransactionDateStart &&
      //   !self.reMmTransactionDateEnd
      // ) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(สิ้นสุด)", "warning");
      //   return false;
      // }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportReturnProduct",
        responseType: "arraybuffer",
        data: {
          StartDate:
            self.reStartDate != null
              ? self.reStartDate.format("DD/MM/YYYY")
              : null,

          EndDate:
            self.reEndDate != null
              ? self.reEndDate.format("DD/MM/YYYY")
              : null,

          Barcode: self.reBarcode,
          ProductTypeId: self.reProductTypeId,
          ProductCode: self.reProductCode,
          ProductBrandId: self.reProductBrandId,
          PlantCode: self.rePlantCode,
          AgentCode: self.reAgentCode,
          ShopCode: self.reShopCode,
          ShopTypeId: self.reShopTypeId,
          TransitId: self.reTransitId,
          TransitType: self.reTransitType,
          ScanUserId: self.reScanUserId,
          ViewPermissionCode: self.reViewPermissionCode,
          JobNumber: self.reJobNumber
          // OrderByCollum: self.reOrderBy != null ? this.OrderName(self.reOrderBy[0][0]) : null,
          // OrderBy: self.reOrderBy != null ? self.reOrderBy[0][1] : null
        },
      })
        .then(function (response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = decodeURIComponent(filename);
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function (error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function () {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
  },
  async mounted() {
    let self = this;

    self.LoadrePlantCodeOptions();
    self.LoadreProductTypeIdOptions();
    self.LoadreProductCodeOptions();
    self.LoadreProductBrandIdOptions();
    self.LoadreAgentCodeOptions();
    // self.LoadreShopCodeOptions();
    self.LoadreShopTypeIdOptions();
    self.LoadreTransitIdOptions();
    self.LoadreTransitTypeOptions();
    // self.LoadreScanUserIdOptions();
    await self.LoadreViewReturnProductOptions();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.reDateReq = moment().format("DD/MM/YYYY h:mm a");

    $(self.$refs.reStartDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reStartDate = moment().set("date",1);
    $(self.$refs.reStartDate)
      .datepicker(
        "update",
        !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function (e) {
        self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reEndDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reEndDate = moment().endOf('month');
    $(self.$refs.reEndDate)
      .datepicker(
        "update",
        !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function (e) {
        self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    var table = $("#ReturnProductTable");
    await self.GenCollums(table);
    self.GetDataTable(table);
    self.LoadFrist = false;

    // set validation rules
    $(this.$refs.form).validate({
      rules: {
        reStartDate: "required",
        reEndDate: "required",
      },
      messages: {
        reStartDate: "กรุณากรอกวันที่เริ่มต้น",
        reEndDate: "กรุณากรอกวันที่สิ้นสุด",
      },
    });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// App/Components/Report/ReturnProduct.vue